import { handleActions } from 'redux-actions';
import { requestDocuments, requestDocumentsSuccess, requestDocumentsReset } from './action';

export interface RequestDocumentsModalState {
  isSubmitting: boolean;
  isSuccess: boolean;
}

const initialState: RequestDocumentsModalState = {
  isSubmitting: false,
  isSuccess: false,
};

const reducer = handleActions<RequestDocumentsModalState>(
  {
    [String(requestDocuments)]: (state) => ({ ...state, isSubmitting: true }),
    [String(requestDocumentsSuccess)]: () => ({ isSubmitting: false, isSuccess: true }),
    [String(requestDocumentsReset)]: () => initialState,
  },
  initialState,
);

export default reducer;
